import { MapSettingEnum, ModeSettingEnum, MODE_BASE_PLAYTIME_MINUTES } from '@colonist/game-base-types';
import { GameModeDataController } from '@colonist/shared-types';
import { MapDataController } from '../../../../shared/map_data/MapDataController.ts';
import { LobbyImage } from '@colonist/types';
import { createDiv, createDivIn, createImgIn } from '../ui_utils/DomUtils.ts';
export function getShuffleQueueModeName(modeId) {
    const modeData = GameModeDataController.getModeDataForMode(modeId);
    if (!modeData) return undefined;
    switch(modeId){
        case ModeSettingEnum.Classic4P:
        case ModeSettingEnum.Classic56P:
        case ModeSettingEnum.Classic78P:
            return undefined;
        case ModeSettingEnum.CitiesAndKnights4P:
        case ModeSettingEnum.CitiesAndKnights56P:
            return {
                key: 'strings:homePage.shuffleQueue.modes.citiesAndKnights'
            };
        case ModeSettingEnum.Seafarers4P:
        case ModeSettingEnum.Seafarers56P:
            return {
                key: 'strings:homePage.shuffleQueue.modes.seafarers'
            };
        case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            return {
                key: 'strings:homePage.shuffleQueue.modes.cnkSeafarers'
            };
        case ModeSettingEnum.ColonistRush4P:
            return {
                key: 'strings:homePage.shuffleQueue.modes.rush'
            };
        default:
            return undefined;
    }
}
export function getShuffleQueueMapName(mapId) {
    const mapData = MapDataController.getMapDataForMap(mapId);
    if (!mapData) return undefined;
    switch(mapId){
        case MapSettingEnum.Classic4P:
        case MapSettingEnum.Classic56P:
        case MapSettingEnum.Classic78P:
            return {
                key: 'strings:homePage.shuffleQueue.maps.base'
            };
        case MapSettingEnum.Classic4PRandom:
            return {
                key: 'strings:homePage.shuffleQueue.maps.random'
            };
        case MapSettingEnum.Earth:
        case MapSettingEnum.EarthSeafarers:
            return {
                key: 'strings:homePage.shuffleQueue.maps.earth'
            };
        case MapSettingEnum.USA:
            return {
                key: 'strings:homePage.shuffleQueue.maps.usa'
            };
        case MapSettingEnum.UK:
        case MapSettingEnum.UKSeafarers:
            return {
                key: 'strings:homePage.shuffleQueue.maps.uk'
            };
        case MapSettingEnum.Diamond:
            return {
                key: 'strings:homePage.shuffleQueue.maps.diamond'
            };
        case MapSettingEnum.Gear:
            return {
                key: 'strings:homePage.shuffleQueue.maps.gear'
            };
        case MapSettingEnum.Lakes:
            return {
                key: 'strings:homePage.shuffleQueue.maps.lakes'
            };
        case MapSettingEnum.Pond:
            return {
                key: 'strings:homePage.shuffleQueue.maps.pond'
            };
        case MapSettingEnum.Twirl:
            return {
                key: 'strings:homePage.shuffleQueue.maps.twirl'
            };
        case MapSettingEnum.ShuffleBoard:
            return {
                key: 'strings:homePage.shuffleQueue.maps.shuffleBoard'
            };
        case MapSettingEnum.BlackForest:
            return {
                key: 'strings:homePage.shuffleQueue.maps.blackForest'
            };
        case MapSettingEnum.Volcano:
            return {
                key: 'strings:homePage.shuffleQueue.maps.volcano'
            };
        case MapSettingEnum.GoldRush:
            return {
                key: 'strings:homePage.shuffleQueue.maps.goldRush'
            };
        case MapSettingEnum.KingOfTheHill:
            return {
                key: 'strings:homePage.shuffleQueue.maps.kingOfTheHill'
            };
        case MapSettingEnum.Circle:
            return {
                key: 'strings:homePage.shuffleQueue.maps.circle'
            };
        case MapSettingEnum.Kite:
            return {
                key: 'strings:homePage.shuffleQueue.maps.kite'
            };
        case MapSettingEnum.Romania:
            return {
                key: 'strings:homePage.shuffleQueue.maps.romania'
            };
        case MapSettingEnum.MiniBase:
            return {
                key: 'strings:homePage.shuffleQueue.maps.miniBase'
            };
        case MapSettingEnum.Monopoly:
            return {
                key: 'strings:homePage.shuffleQueue.maps.monopoly'
            };
        case MapSettingEnum.MountainOfRiches:
            return {
                key: 'strings:homePage.shuffleQueue.maps.mountainOfRiches'
            };
        case MapSettingEnum.Doggo:
            return {
                key: 'strings:homePage.shuffleQueue.maps.doggo'
            };
        case MapSettingEnum.Duel:
            return {
                key: 'strings:homePage.shuffleQueue.maps.duel'
            };
        case MapSettingEnum.TradeIslands:
        case MapSettingEnum.TradeIslandsSeafarers:
            return {
                key: 'strings:homePage.shuffleQueue.maps.tradeIslands'
            };
        case MapSettingEnum.Vietnam:
            return {
                key: 'strings:homePage.shuffleQueue.maps.vietnam'
            };
        case MapSettingEnum.TurningTidesSeafarers:
        case MapSettingEnum.TurningTidesClassic:
            return {
                key: 'strings:homePage.shuffleQueue.maps.turningTides'
            };
        case MapSettingEnum.TwoIsles:
            return {
                key: 'strings:homePage.shuffleQueue.maps.twoIsles'
            };
        case MapSettingEnum.JellyFish:
            return {
                key: 'strings:homePage.shuffleQueue.maps.jellyfish'
            };
        case MapSettingEnum.Istanbul:
        case MapSettingEnum.IstanbulSeafarers:
            return {
                key: 'strings:homePage.shuffleQueue.maps.istanbul'
            };
        case MapSettingEnum.Europe:
        case MapSettingEnum.EuropeSeafarers:
            return {
                key: 'strings:homePage.shuffleQueue.maps.europe'
            };
        case MapSettingEnum.Stripes:
            return {
                key: 'strings:homePage.shuffleQueue.maps.stripes'
            };
        case MapSettingEnum.MonopolyIslands:
        case MapSettingEnum.MonopolyIslandsSeafarers:
            return {
                key: 'strings:homePage.shuffleQueue.maps.monopolyIslands'
            };
        case MapSettingEnum.SS1HeadingForNewShores3P:
        case MapSettingEnum.SS1HeadingForNewShores4P:
        case MapSettingEnum.SS1HeadingForNewShores56P:
            return {
                key: 'strings:homePage.shuffleQueue.maps.headingForNewShores'
            };
        case MapSettingEnum.SS2FourIslands3P:
        case MapSettingEnum.SS2FourIslands4P:
        case MapSettingEnum.SS2SixIslands56P:
            return {
                key: 'strings:homePage.shuffleQueue.maps.fourIslands'
            };
        case MapSettingEnum.SS3FogIslands3P:
        case MapSettingEnum.SS3FogIslands4P:
        case MapSettingEnum.SS3FogIslands56P:
            return {
                key: 'strings:homePage.shuffleQueue.maps.fogIslands'
            };
        case MapSettingEnum.SS4ThroughTheDesert3P:
        case MapSettingEnum.SS4ThroughTheDesert4P:
        case MapSettingEnum.SS4ThroughTheDesert56P:
            return {
                key: 'strings:homePage.shuffleQueue.maps.throughTheDesert'
            };
        default:
            return undefined;
    }
}
export function createShuffleQueueIconStack(mapId, modeId) {
    const mapImage = getShuffleQueueMapImage(mapId);
    if (mapImage == undefined) return undefined;
    const modeImage = getShuffleQueueModeImage(modeId);
    const container = createDiv('shuffle-queue-icon');
    createImgIn(container, LobbyImage.GameModeShuffle, 'shuffle-queue-icon-shuffle-card');
    const detailsContainer = createDivIn(container, 'shuffle-queue-icon-details');
    createImgIn(detailsContainer, mapImage, 'shuffle-queue-icon-map');
    if (modeImage != undefined) createImgIn(detailsContainer, modeImage, 'shuffle-queue-icon-mode');
    return container;
}
function getShuffleQueueMapImage(mapId) {
    const mapData = MapDataController.getMapDataForMap(mapId);
    return mapData === null || mapData === void 0 ? void 0 : mapData.image;
}
function getShuffleQueueModeImage(modeId) {
    const modeData = GameModeDataController.getModeDataForMode(modeId);
    if (!modeData) return undefined;
    switch(modeId){
        case ModeSettingEnum.Classic4P:
        case ModeSettingEnum.Classic56P:
        case ModeSettingEnum.Classic78P:
            return undefined;
        case ModeSettingEnum.Seafarers4P:
        case ModeSettingEnum.Seafarers56P:
            return LobbyImage.GameModeSeafarers;
        case ModeSettingEnum.CitiesAndKnights4P:
        case ModeSettingEnum.CitiesAndKnights56P:
            return LobbyImage.GameModeCnK;
        case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            return LobbyImage.GameModeCnKSeafarers;
        case ModeSettingEnum.ColonistRush4P:
            return LobbyImage.GameModeColonistRush;
        default:
            return undefined;
    }
}
function getPlayerCountPlayTimeMultiplier(playerCount) {
    switch(playerCount){
        case 2:
            return 0.50;
        case 3:
            return 0.75;
        case 4:
            return 1.00;
        case 5:
            return 1.125;
        case 6:
            return 1.25;
        case 7:
            return 1.375;
        case 8:
            return 1.50;
        default:
            return 1.00;
    }
}
function getModeBasePlayTime(modeId) {
    switch(modeId){
        case ModeSettingEnum.Classic4P:
        case ModeSettingEnum.Classic56P:
        case ModeSettingEnum.Classic78P:
            return MODE_BASE_PLAYTIME_MINUTES.CLASSIC;
        case ModeSettingEnum.CitiesAndKnights4P:
        case ModeSettingEnum.CitiesAndKnights56P:
            return MODE_BASE_PLAYTIME_MINUTES.CITIES_AND_KNIGHTS;
        case ModeSettingEnum.Seafarers4P:
        case ModeSettingEnum.Seafarers56P:
            return MODE_BASE_PLAYTIME_MINUTES.SEAFARERS;
        case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            return MODE_BASE_PLAYTIME_MINUTES.CITIES_AND_KNIGHTS_SEAFARERS;
        case ModeSettingEnum.ColonistRush4P:
            return MODE_BASE_PLAYTIME_MINUTES.COLONIST_RUSH;
        default:
            return 30;
    }
}
export function getShuffleQueuePlayTimeForPlayerCount(playerCount, modeId) {
    if (playerCount == undefined || modeId == undefined) {
        return 30;
    }
    const baseTime = getModeBasePlayTime(modeId);
    const multiplier = getPlayerCountPlayTimeMultiplier(playerCount);
    return Math.round(baseTime * multiplier / 5) * 5;
}
